module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/~/readable-stream/transform.js
// module id = 779
// module chunks = 1